import {
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Box,
  GridItem,
  Grid,
  IconButton,
  Icon,
  Heading,
  Text,
} from "@chakra-ui/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import { selectConstants } from "../../../../../common/slices/constantsSlice";
import IButton, { BUTTON } from "../../../../../components/IButton";
import { useAppDispatch } from "../../../../../store";
import { wizardNextStep, wizardPrevStep } from "../../connectionSlice";
import { CopyTextToClipboard } from "./CopyDatabaseName";

export default function BigqueyAccessRequestDetails({
  onClose,
}: {
  onClose: () => void;
}) {
  const {
    authedConstants: { gcp_service_account_email },
  } = useSelector(selectConstants);

  const dispatch = useAppDispatch();

  return (
    <>
      <ModalHeader color="blue.700" fontSize="md" pl={2}>
        <IconButton
          aria-label="Go Back"
          variant="ghost"
          size="sm"
          icon={<Icon as={FaArrowLeft} />}
          mr={2}
          onClick={() => dispatch(wizardPrevStep())}
        />
        Required permissions
        <ModalCloseButton />
      </ModalHeader>
      <ModalBody px={7}>
        <Heading fontSize="sm" pb={2}>
          Verifying access to the datasets
        </Heading>
        <Text fontSize="12px" pt={2} mb={5}>
          Inflection requires specific permissions to sync data. A service
          account is used to sync data between your dataset and Inflection’s
          data storage. Go to BigQuery, select on your dataset. Click on Sharing{" "}
          <Icon as={FaArrowRight} fontSize="8px" />
          Permissions. Add the below service account as principal and add the
          following roles. The following permissions are required.
        </Text>

        <Box px={1} fontSize="12px">
          <Grid
            templateColumns="repeat(2,2fr)"
            gridTemplateColumns={"60px 1fr"}
            gap={3}
          >
            <GridItem colSpan={2}>
              1. Give BigQuery Viewer & BigQuery User permissions to your
              project in which your dataset resides. This will help us read the
              data and sync the data to Inflection
            </GridItem>
            <GridItem mt={2} color="gray.600">
              Principal:
            </GridItem>
            <GridItem>
              <CopyTextToClipboard text={gcp_service_account_email} />
            </GridItem>
            <GridItem color="gray.600">Role:</GridItem>
            <GridItem>bigquery.dataviewer, bigquery.user</GridItem>
          </Grid>

          <Grid
            templateColumns="repeat(2,3fr)"
            gridTemplateColumns={"60px 1fr"}
            gap={3}
            mt={6}
          >
            <GridItem colSpan={2}>
              2. Give BigQuery Editor permissions to the dataset you just
              created. This dataset is used to transfer the data from the other
              dataset to Inflection.
            </GridItem>
            <GridItem mt={2} color="gray.600">
              Principal:
            </GridItem>
            <GridItem>
              <CopyTextToClipboard text={gcp_service_account_email} />
            </GridItem>
            <GridItem color="gray.600">Role:</GridItem>
            <GridItem>bigquery.dataEditor</GridItem>
            <GridItem color="gray.600">Dataset:</GridItem>
            <GridItem>Inflection</GridItem>
          </Grid>
        </Box>
      </ModalBody>
      <ModalFooter my={1}>
        <IButton variant={BUTTON.SECONDARY} onClick={onClose} mr={3}>
          cancel
        </IButton>
        <IButton
          variant={BUTTON.PRIMARY}
          onClick={() => {
            dispatch(wizardNextStep());
          }}
        >
          Continue
        </IButton>
      </ModalFooter>
    </>
  );
}
